(() => {
  const init = (root) => {
    if (root.dataset.quoteReady) return;
    root.dataset.quoteReady = 'true';
    const groups = [...root.querySelectorAll('[data-family]')];
    if (!groups.length) return;
    const links = [...root.querySelectorAll('[data-family-select]')];
    const labels = JSON.parse(root.querySelector('[data-quote-directory-labels]').textContent);
    const status = root.querySelector('[data-quote-status]');
    const apply = () => {
      const key = decodeURIComponent(location.hash.slice(1));
      const selected = groups.find(g => g.dataset.family === key);
      let count = 0;
      groups.forEach(g => {
        g.hidden = !!selected && g !== selected;
        if (!g.hidden) count += Number(g.dataset.count);
      });
      links.forEach(a => {
        const current = a.dataset.familySelect === (selected ? key : 'all');
        if (current) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
      status.textContent = `${count} ${labels.models} · ${selected ? selected.dataset.familyName : labels.all}`;
    };
    links.forEach(a => a.addEventListener('click', (event) => {
      event.preventDefault();
      history.pushState(null, '', a.getAttribute('href'));
      apply();
      status.scrollIntoView({block: 'start', behavior: 'auto'});
    }));
    window.addEventListener('hashchange', apply);
    window.addEventListener('popstate', apply);
    apply();
    if (location.hash && groups.some(g => '#'+g.dataset.family === location.hash)) {
      requestAnimationFrame(() => status.scrollIntoView({block:'start',behavior:'auto'}));
    }
  };
  const scan = () => document.querySelectorAll('[data-quote-directory]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
